import React from 'react';
import PropTypes from 'prop-types';

import styles from './YoutubeEmbed.module.scss';

const YoutubeEmbed = ({ youtubeLink }) => {
  const getVideoId = (link) => {
    const videoIdRegex = /(?:\?v=|\/embed\/|\/watch\?v=|youtu.be\/)([^&?/]+)/;
    const match = link.match(videoIdRegex);
    return match ? match[1] : null;
  };

  const videoId = getVideoId(youtubeLink);

  if (!videoId) {
    return <div>Invalid YouTube link</div>;
  }

  return (
    <div className={styles.responsive}>
      <iframe
        src={`https://www.youtube.com/embed/${videoId}`}
        frameBorder="0"
        allow="
        accelerometer;
        autoplay;
        clipboard-write;
        encrypted-media;
        gyroscope; picture-in-picture"
        allowFullScreen
        title="Embedded youtube"
      />
    </div>
  );
};

YoutubeEmbed.propTypes = {
  youtubeLink: PropTypes.string.isRequired,
};

export default YoutubeEmbed;
